
    import api from "./api/openai";
    import { defineComponent } from "@vue/runtime-core";
    import InputText from "./components/misc/InputText.vue";
    import InputTextarea from "./components/misc/InputTextarea.vue";
    import Tabs, { ITab } from "./components/misc/Tabs.vue";

    export default defineComponent({
        components: {
            Tabs,
            InputTextarea,
            InputText,

        },
        data() {
            return {
                tab: "",
                tabs: [
                    { label: "Text", value: "" },
                    { label: "Code", value: "code" },
                ] as ITab[],
                result: "",
                isLoading: false,
                promt: "",
                apiKey: "",
                api,
            };
        },
        computed: {

        },
        methods: {
            async run() {
                if (!this.isLoading) {
                    this.isLoading = true;
                    try {
                        const res = await api[this.tab === "code" ? "getCodeFirst" : "getFirst"](this.promt);
                        this.result = res || "";
                    } catch (e) {
                        console.error("App error: " + e);
                    } finally {
                        this.isLoading = false;
                    }
                }
            },

        },
    });

    